import React, { useState } from "react";
import RadioButton from "../../ui/widgets/radiobutton";
import RadioButtonContainer from "../../ui/layout/page/forms-container/form-item-container/radio-button-container/input-container";
import { RadioButtonItem } from "../../ui/widgets/radiobutton/types";
import { useMessageSource } from "react-message-source";
import Uploader from "./uploader";
import {
  BasicAccountApplicationAttachmentsDocument,
  BasicAccountApplicationDocument,
} from "../../api/commercial/generated-types";
import GridItem from "../../ui/layout/page/grid-item";

interface CompanyDocumentUploadProps {
  basicAccountApplication: BasicAccountApplicationDocument;
  companyAttachments: BasicAccountApplicationAttachmentsDocument[];
}

export const CompanyDocumentUpload = ({
  basicAccountApplication,
  companyAttachments,
}: CompanyDocumentUploadProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const [activeAttachmentDocumentType, setActiveAttachmentDocumentType] =
    useState<
      | BasicAccountApplicationAttachmentsDocument["attachmentDocumentType"]
      | undefined
    >(companyAttachments[0].attachmentDocumentType);

  const [isUploadInProgress, setIsUploadInProgress] = useState<boolean>(false);
  const applicationRef = basicAccountApplication.applicationRef;
  const radioButtonItems: RadioButtonItem[] = companyAttachments.map(
    (attachment: BasicAccountApplicationAttachmentsDocument) => {
      const radioButtonItem: RadioButtonItem = {
        id: attachment.attachmentDocumentType,
        value: attachment.attachmentDocumentType,
        label: getMessage(
          `DocumentUpload.radiobutton-option-${attachment.attachmentDocumentType}`,
        ),
      };
      return radioButtonItem;
    },
  );

  const getAttachmentMetaFrom = (
    attachmentDocumentType: BasicAccountApplicationAttachmentsDocument["attachmentDocumentType"],
  ):
    | BasicAccountApplicationAttachmentsDocument["attachmentMetaDocument"]
    | undefined => {
    const attachmentDocument: BasicAccountApplicationAttachmentsDocument =
      companyAttachments.find(
        (attachment: BasicAccountApplicationAttachmentsDocument) => {
          return attachment.attachmentDocumentType === attachmentDocumentType;
        },
      );
    return attachmentDocument.attachmentMetaDocument ?? undefined;
  };

  return (
    <>
      <RadioButtonContainer>
        <RadioButton
          disabled={isUploadInProgress}
          selectedValue={activeAttachmentDocumentType}
          id="company-document-upload-radiobutton"
          name="company-document-upload-radiobutton"
          values={radioButtonItems}
          onClick={(radioButtonItem: RadioButtonItem) => {
            setActiveAttachmentDocumentType(
              radioButtonItem.value as BasicAccountApplicationAttachmentsDocument["attachmentDocumentType"],
            );
          }}
        />
      </RadioButtonContainer>
      <GridItem>
        <div className="scd-upload-wrapper">
          {activeAttachmentDocumentType && (
            <Uploader
              key={activeAttachmentDocumentType}
              preloadedUpload={getAttachmentMetaFrom(
                activeAttachmentDocumentType,
              )}
              dataForUploading={{
                applicationRef,
                attachmentType: activeAttachmentDocumentType,
              }}
              uploadInProgress={{
                isUploadInProgress,
                setIsUploadInProgress,
              }}
            />
          )}
        </div>
      </GridItem>
    </>
  );
};
